export const CREATE_FORM_JSON = "CREATE_FORM_JSON";
export const SAVE_FORM_JSON = "SAVE_FORM_JSON";
export const UPDATE_PARENT_FIELDS = "UPDATE_PARENT_FIELDS";
export const UPDATE_STEPS_ORDER = "UPDATE_STEPS_ORDER"
export const SELECTED_FORM_ID = "SELECTED_FORM_ID";
export const UPDATE_SELECTED_FORM_ID = "UPDATE_SELECTED_FORM_ID";
export const SELECTED_VIEWPORT = "SELECTED_VIEWPORT";
export const REMOVE_ELEMENT = "REMOVE_ELEMENT";
export const TRANSFER_ELEMENT_REFERENCE = "TRANSFER_ELEMENT_REFERENCE";
export const UPDATE_ELEMENT = "UPDATE_ELEMENT";
export const REORDER_ELEMENT_REFERENCE = "REORDER_ELEMENT_REFERENCE";
export const SET_GRID_SELECTION = "SET_GRID_SELECTION";
export const UPDATE_GRID_STYLES = "UPDATE_GRID_STYLES";
export const SELECTED_DEVICETYPE = "SELECTED_DEVICETYPE";
export const CLEAR_FORM_V2_JSON = "CLEAR_FORM_V2_JSON";
export const INITIALIZE_FORM_V2_JSON = "INITIALIZE_FORM_V2_JSON";
export const DELETE_BY_VALIDATION_KEY = "DELETE_BY_VALIDATION_KEY";
export const SET_MODAL_VISIBILITY = "SET_MODAL_VISIBILITY";
export const UPDATE_MODAL_CONTENT = "UPDATE_MODAL_CONTENT";
export const SET_SNACKBAR_VISIBILITY = "SET_SNACKBAR_VISIBILITY";
export const UPDATE_CANVAS_CONFIG = "UPDATE_CANVAS_CONFIG"
export const SELECTED_DEVICE = "SELECTED_DEVICE";
// assets
export const SET_ASSETS = "SET_ASSETS"
export const CREATE_ASSET = "CREATE_ASSET"
export const DELETE_ASSET = "DELETE_ASSET"
export const UNLINK_ASSET = "UNLINK_ASSET"
export const SET_ASSET_EDIT_MODE = "SET_ASSET_EDIT_MODE"
export const DISCARD_ASSET_CHANGES = "DISCARD_ASSET_CHANGES"

// context-menu
export const UPDATE_SELECTED_ELEMENTS = "UPDATE_SELECTED_ELEMENTS";
export const CLEAR_SELECTED_ITEMS = "CLEAR_SELECTED_ITEMS";
export const SET_MULTIPLE_SELECT = "SET_MULTIPLE_SELECT";
export const PASTE_COPIED_ELEMENT = "PASTE_COPIED_ELEMENT";
export const GROUP_ELEMENTS = "GROUP_ELEMENTS";
export const UN_GROUP_ELEMENTS = "UN_GROUP_ELEMENTS";

// undo redo
export const UNDO = "UNDO";
export const REDO = "REDO";
export const INITIALIZE_ACTION_STACK = "INITIALIZE_ACTION_STACK";
export const PUSH_FORM_ACTION_STACK = "PUSH_FORM_ACTION_STACK";
export const UNDO_DELETE_ELEMENT = "UNDO_DELETE_ELEMENT";
export const REDO_ELEMENT_DROP = "REDO_ELEMENT_DROP";
export const UNDO_DROP_ELEMENT = 'UNDO_DROP_ELEMENT';
export const UPDATE_ELEMENT_ON_UNDO_OR_REDO = "UPDATE_ELEMENT_ON_UNDO_OR_REDO";
export const REORDER_UNDO_ELEMENT_REFERENCE = "REORDER_UNDO_ELEMENT_REFERENCE";
export const TRANSFER_UNDOREDO_ELEMENT_REFERENCE = "TRANSFER_UNDOREDO_ELEMENT_REFERENCE";
export const UPDATE_TAB = "UPDATE_TAB"
export const UPDATE_TAB_ID = "UPDATE_TAB_ID"
export const  FIXED_ELEMENTS_ARRAY ="FIXED_ELEMENTS_ARRAY";
export const  FIXED_ELEMENTS_ARRAY_V3 ="FIXED_ELEMENTS_ARRAY_V3";
export const  FIXED_ELEMENTS_ARRAY_UPDATE_V3 ="FIXED_ELEMENTS_ARRAY_UPDATE_V3";
export const  DELETE_FIXED_ELEMENT ="DELETE_FIXED_ELEMENT";


// form properties
export const UPDATE_V2_FORM_PROPERTIES = "UPDATE_V2_FORM_PROPERTIES"

// computed styles
export const IS_V3_FORMS = "IS_V3_FORMS"
export const ADD_COMPUTED_STYLES = "ADD_COMPUTED_STYLES"
export const ADD_CUSTOM_STYLE_URL = "ADD_CUSTOM_STYLE_URL"
export const ADD_WRAPPER_COMPUTED_STYLES = "ADD_WRAPPER_COMPUTED_STYLES"
export const COPY_STYLES = "COPY_STYLES"
export const COPY_CANVAS_STYLES = "COPY_CANVAS_STYLES"
export const APPLY_STYLES = "APPLY_STYLES"
export interface Component {
  [key: string]: FormCreationData;
}

export type DeviceType = 'Sm' | 'Md' | 'Lg'

export type Device = {
  name: string,
  resolution: string
}

export interface GridStyles {
  common: React.CSSProperties
  Sm: {
    [key: string]: any;
  }
  Md: {
    [key: string]: any;
  }
  Lg: {
    [key: string]: any;
  }
}

export interface Modal {
  visible: boolean;
  componentId: string;
  isCustom?: boolean;
}
export interface Snackbar {
  visible: boolean;
  componentId: string;
}

export interface CanvasConfig {
  onLoad: string;
  [key: string]: any;
}

export interface IAsset {
  id: string
  assetId: string
  label: string
  json: {
    components: Component;
    componentOrder: string[];
  }
}

export interface IAssets {
  [key: string]: IAsset
}

export interface IAssetEditMode {
  isEnabled: boolean
  assetId: string
  asset: IAsset | null
}

export interface TreeViewVisibility {
  components: {
    [key: string]: boolean
  },
  canvas: boolean
}

export interface FormStack {
  actionStack: FormCreationData[];
  actionPointer: number;
  components: Component;
  componentOrder: string[];
  selectedElementId: string;
  deviceType: DeviceType;
  device: Device;
  isGridSelected: boolean;
  isAssetInstanceSelected: boolean;
  gridStyles: GridStyles;
  snackbar: Snackbar;
  canvasConfig: CanvasConfig 
  assets: IAssets
  assetEditMode: IAssetEditMode
  modal: Modal;
  selectedElementsId: any;
  fixedArray: string[];
  fixedArrayV3?: any;
  formProperties: any;
  computedStyles:any;
  wrapperComputedStyles:any;
  styleUrl: any;
  isCoreV3: any;
  newId: any;
}

export interface APIFormData {
  components: Component;
  componentOrder: string[];
  gridStyles: GridStyles;
  version: string
  isCoreV3?: any
  selectedElementId?: string
}

export interface FormCreationData {
  parentId?: string;
  id: string;
  label: string;
  properties: any;
  fields: string[];
  type: string;
  [key: string]: any;
  modal?: any;
  increment?:number;
  fixedArray?: string[]
}
export interface FormCreation {
  type:
    | typeof CREATE_FORM_JSON
    | typeof SAVE_FORM_JSON
    | typeof UPDATE_PARENT_FIELDS
    | typeof UPDATE_STEPS_ORDER
    | typeof SELECTED_FORM_ID
    | typeof UPDATE_SELECTED_FORM_ID
    | typeof REMOVE_ELEMENT
    | typeof TRANSFER_ELEMENT_REFERENCE
    | typeof UPDATE_ELEMENT
    | typeof REORDER_ELEMENT_REFERENCE
    | typeof SET_GRID_SELECTION
    | typeof UPDATE_GRID_STYLES
    | typeof SELECTED_DEVICETYPE
    | typeof CLEAR_FORM_V2_JSON
    | typeof INITIALIZE_FORM_V2_JSON
    | typeof DELETE_BY_VALIDATION_KEY
    | typeof SET_MODAL_VISIBILITY
    | typeof UPDATE_MODAL_CONTENT
    | typeof UPDATE_CANVAS_CONFIG
    | typeof SET_SNACKBAR_VISIBILITY
    | typeof SET_ASSET_EDIT_MODE
    | typeof SET_ASSETS
    | typeof CREATE_ASSET
    | typeof DELETE_ASSET
    | typeof DISCARD_ASSET_CHANGES
    | typeof UNLINK_ASSET
    | typeof UNDO
    | typeof REDO
    | typeof INITIALIZE_ACTION_STACK
    | typeof PUSH_FORM_ACTION_STACK
    | typeof UNDO_DELETE_ELEMENT
    | typeof UPDATE_TAB
    | typeof UPDATE_TAB_ID
    | typeof UPDATE_SELECTED_ELEMENTS
    | typeof CLEAR_SELECTED_ITEMS
    | typeof PASTE_COPIED_ELEMENT
    | typeof GROUP_ELEMENTS
    | typeof UN_GROUP_ELEMENTS
    | typeof SELECTED_DEVICE
    | typeof  FIXED_ELEMENTS_ARRAY
    | typeof  FIXED_ELEMENTS_ARRAY_V3
    | typeof  FIXED_ELEMENTS_ARRAY_UPDATE_V3
    | typeof  DELETE_FIXED_ELEMENT
    | typeof UPDATE_V2_FORM_PROPERTIES
    | typeof IS_V3_FORMS
    | typeof ADD_COMPUTED_STYLES
    | typeof ADD_WRAPPER_COMPUTED_STYLES
    | typeof ADD_CUSTOM_STYLE_URL
    | typeof COPY_STYLES
    | typeof COPY_CANVAS_STYLES
    | typeof APPLY_STYLES
  data: FormCreationData;
}
